import client from '../client'

export const calculatePaymentKey = `${process.env.NEXT_PUBLIC_PURCHASE_DOMAIN}/api/Calculations/CalculatePayment`

export async function calculatePayment({
  vehicleId,
  paymentType,
  term,
  interestRate,
  downPayment,
  paymentFrequency,
  purchase,
}) {
  const params = new URLSearchParams({
    vehicleId,
    paymentType,
    term,
    interestRate,
    downPayment,
    paymentFrequency,
    purchase,
  })

  return client(`${calculatePaymentKey}?${params.toString()}`)
}
